<section hlmCard aria-labelledby="partner-link-title">
  <div hlmCardHeader>
    <h2 hlmCardTitle id="partner-link-title">Dein Empfehlungslink</h2>
    <p hlmCardDescription>
      Wer sich über diesen Link bei Schenkwerk registriert, wird dir zugeordnet.
    </p>
  </div>
  <div hlmCardContent>
    <div class="flex flex-col gap-2 sm:flex-row">
      <input
        hlmInput
        readonly
        class="font-mono text-sm sm:flex-1"
        aria-label="Dein Empfehlungslink"
        [value]="link()"
        (focus)="$any($event.target).select()" />
      <button hlmBtn type="button" (click)="copy()">
        <ng-icon [name]="copied() ? 'lucideCheck' : 'lucideCopy'" data-icon="inline-start" />
        {{ copied() ? 'Kopiert' : 'Link kopieren' }}
      </button>
    </div>
  </div>
</section>
